<template>
  <div class="container-fluid d-flex h-100 flex-column">
    <div class="row g-0 py-4">
      <div class="col text-center">
        <p class="card-text">
          {{ t('billing_details.subscription_setup_incomplete') }}
          <a href="mailto:support@authenticlabs.com" target="_blank">support@authenticlabs.com</a>.
        </p>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from "vue-i18n";
const { t } = useI18n();
</script>